module.exports = __webpack_public_path__ + "79acfe05d691a1b39a60c935c635f97d.svg";